var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('label',{staticClass:"formLabel"},[(_vm.isRequired)?_c('span',{staticClass:"labelBadge--required"},[_vm._v("必須")]):_vm._e(),_vm._v(" "),(_vm.showOptional)?_c('span',{staticClass:"labelBadge--optional"},[_vm._v("任意")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740630c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/uFes/components/FormLabelFes.vue
// module id = null
// module chunks = 